module.exports = __webpack_public_path__ + "static/media/testfile_pieonsensei.64fb9420.zip";